import React, { type FunctionComponent } from 'react'
import { useRouteMatch } from 'react-router'
import { DashSwitch } from 'legacy/dash-components/dash-switch/DashSwitch'
import { DashRoute } from 'legacy/dash-components/dash-route/DashRoute'
import { DashRedirect } from 'legacy/dash-components/dash-redirect/DashRedirect'
import { PublicSection } from 'domains/public/PublicSection'
import { useCurrentAccountDetails } from 'api/current-account/currentAccount.hooks'
import { DASH_ROUTE_URLS } from 'utils/routing/routes'
import { RouteSuspense } from 'legacy/dash-components/route-suspense/RouteSuspense'

export const PublicRoutes: FunctionComponent = () => {
  const { loading, authorized } = useCurrentAccountDetails()
  const publicLogInRouteMatch = useRouteMatch(DASH_ROUTE_URLS['public-log-in'])

  if (loading) {
    return null
  }

  // If already authorized, and they are heading to the log-in page, direct them to the redirect page
  if (authorized && publicLogInRouteMatch) {
    return <DashRedirect toRoute="app-halt-redirect" />
  }

  return (
    <RouteSuspense>
      <DashSwitch>
        <DashRoute route="public" component={PublicSection} />
        <DashRedirect toRoute="public" />
      </DashSwitch>
    </RouteSuspense>
  )
}
